import createClient from 'openapi-fetch';
import type { paths } from './schema';
import { API_BASE } from '@/config/constants';
import { ApiError } from './errors';

/** Per-request auth context for guest-upload JWTs and share-link pages (§6.1). */
const authContext: { guestJwt: string | null; shareToken: string | null } = {
  guestJwt: null,
  shareToken: null,
};
export function setGuestJwt(jwt: string | null): void {
  authContext.guestJwt = jwt;
}
export function setShareToken(token: string | null): void {
  authContext.shareToken = token;
}

export const client = createClient<paths>({ baseUrl: API_BASE, credentials: 'include' });

client.use({
  onRequest({ request }) {
    request.headers.set('x-request-id', crypto.randomUUID());
    if (authContext.guestJwt && !request.headers.has('Authorization')) {
      request.headers.set('Authorization', `Bearer ${authContext.guestJwt}`);
    }
    return request;
  },
});

type FetchResult = { data?: unknown; error?: unknown; response: Response };

/** Unwraps an openapi-fetch result, converting non-2xx into `ApiError`. */
export async function req<T extends FetchResult>(p: Promise<T>): Promise<NonNullable<T['data']>> {
  let r: T;
  try {
    r = await p;
  } catch (e) {
    throw ApiError.network(e);
  }
  if (!r.response.ok) throw await ApiError.fromResponse(r.response, r.error);
  return r.data as NonNullable<T['data']>;
}

/** Plain JSON fetch for non-OpenAPI URLs (sprite index, waveform peaks, transcript JSON). */
export async function fetchJson<T>(url: string, init?: RequestInit): Promise<T> {
  let res: Response;
  try {
    res = await fetch(url, init);
  } catch (e) {
    throw ApiError.network(e);
  }
  if (!res.ok) throw await ApiError.fromResponse(res);
  return (await res.json()) as T;
}

export const api = client;
